import { render, staticRenderFns } from "./adddistributionLevelConfig.vue?vue&type=template&id=151663ac&scoped=true&"
import script from "./adddistributionLevelConfig.vue?vue&type=script&lang=js&"
export * from "./adddistributionLevelConfig.vue?vue&type=script&lang=js&"
import style0 from "./adddistributionLevelConfig.vue?vue&type=style&index=0&id=151663ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151663ac",
  null
  
)

export default component.exports